import{__module as r}from"../../_virtual/index2.mjs";import{__require as o}from"./factoryWithThrowingShims.mjs";var e;function s(){return e?r.exports:(e=1,r.exports=o()(),r.exports)}export{s as __require};
